

    export class SplashChicken extends Phaser.Group {

        private chicken1: Phaser.Image;
        private chicken2: Phaser.Image;
        private chicken3: Phaser.Image;
        private f: number;
        private animateChicken: boolean;

        constructor(game: Phaser.Game) {

            super(game, null, "splash-chicken");

            this.f = 0;
            this.animateChicken = false;

            this.chicken1 = new Phaser.Image(this.game, -50, 365, "texture_atlas_1", "splash-chicken1.png");
            this.chicken1.anchor.y = 1;
            this.chicken1.angle = -90;
            this.add(this.chicken1);

            this.chicken2 = new Phaser.Image(this.game, 70 - 185, 450, "texture_atlas_1", "splash-chicken2.png");
            this.chicken2.anchor.set(.5, 1);
            this.add(this.chicken2);

            this.chicken3 = new Phaser.Image(this.game, 185, 485 + 150, "texture_atlas_1", "splash-chicken3.png");
            this.chicken3.anchor.set(.5, 1);
            this.add(this.chicken3);
        }

        public update(): void {

            super.update();

            this.f ++;

            if (this.animateChicken) {

                if (this.f > 100) {
                    this.animateChicken = false;
                    this.animateChicken1();
                }
                
            } else {

                if (this.f === 15) {

                    this.game.add.tween(this.chicken1)
                        .to({angle: 0}, 350, Phaser.Easing.Cubic.InOut, true, 250);
    
                    this.game.add.tween(this.chicken2)
                        .to({x: 70}, 450, Phaser.Easing.Cubic.InOut, true, 500);
    
                    this.game.add.tween(this.chicken3)
                        .to({y: 485}, 450, Phaser.Easing.Elastic.Out, true, 750)
                        .onComplete.add(function(): void {
                            this.animateChicken = true;
                        }, this);
                }
            }            
        }

        private animateChicken1(): void {
            
            this.game.add.tween(this.chicken1)
                .to({angle: 5}, 150, Phaser.Easing.Cubic.Out, true, 250, 0, true)
                .onComplete.add(this.animateChicken2, this);
        }

        private animateChicken2(): void {
            
            this.game.add.tween(this.chicken2)
                .to({y: this.chicken2.y + 10}, 125, Phaser.Easing.Cubic.Out, true, 250, 0, true)
                .onComplete.add(this.animateChicken3, this);
        }

        private animateChicken3(): void {
            
            this.game.add.tween(this.chicken3)
                .to({y: this.chicken3.y + 10}, 125, Phaser.Easing.Cubic.Out, true, 250, 0, true)
                .onComplete.add(this.animateChicken1, this);
        }
    }
